import { jsx as _jsx } from "react/jsx-runtime";
import { availabilityLabel, checkResultLabel, obligationStateLabel, obligationStatusLabel, verificationLabel, } from '@kanos/domain';
import { cx } from './cx.js';
const tones = {
    neutral: 'bg-neutral-bg text-neutral-fg',
    info: 'bg-info-bg text-info-fg',
    success: 'bg-success-bg text-success-fg',
    warning: 'bg-warning-bg text-warning-fg',
    danger: 'bg-danger-bg text-danger-fg',
};
/** Colour alone carries no meaning (WCAG 1.4.1): every status always has a text as well. */
export function StatusBadge({ tone, children, pending = false }) {
    return (_jsx("span", { className: cx('inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold leading-5 whitespace-nowrap', tones[tone], pending && 'outline outline-1 outline-dashed outline-current/40'), children: children }));
}
const availabilityTone = {
    present: 'info',
    unknown: 'warning',
    not_collected: 'neutral',
    not_applicable: 'neutral',
};
const verificationTone = {
    open: 'neutral',
    evidenced: 'info',
    verified: 'success',
    contradictory: 'danger',
};
const checkResultTone = {
    fulfilled: 'success',
    not_fulfilled: 'danger',
    not_conclusive: 'warning',
    case_review_required: 'warning',
    technical_error: 'danger',
};
const obligationTone = {
    applicable: 'info',
    conditional_clarify: 'warning',
    not_applicable: 'neutral',
};
export const AvailabilityBadge = ({ value }) => (_jsx(StatusBadge, { tone: availabilityTone[value], pending: value === 'unknown', children: availabilityLabel[value] }));
export const VerificationBadge = ({ value }) => (_jsx(StatusBadge, { tone: verificationTone[value], children: verificationLabel[value] }));
export const CheckResultBadge = ({ value }) => (_jsx(StatusBadge, { tone: checkResultTone[value], pending: value === 'case_review_required', children: checkResultLabel[value] }));
export const ObligationBadge = ({ value }) => (_jsx(StatusBadge, { tone: obligationTone[value], pending: value === 'conditional_clarify', children: obligationStatusLabel[value] }));
/**
 * The result for one obligation: its status where the rules derived one; otherwise why there
 * is none. A rule that could not be evaluated is shown as an error, never as a quiet result.
 */
export function ObligationResultBadge({ state, status, }) {
    if (state === 'derived' && status !== null)
        return _jsx(ObligationBadge, { value: status });
    if (state === 'evaluation_error') {
        return _jsx(StatusBadge, { tone: "danger", children: obligationStateLabel[state] });
    }
    return (_jsx(StatusBadge, { tone: "neutral", pending: true, children: obligationStateLabel[state] }));
}
//# sourceMappingURL=status-badge.js.map